module.exports = __webpack_public_path__ + "media/moonlight_in_mondstadt.77505fcc.mp3";